import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ToolingSearchService } from '../../../../../services/tooling-search.service';
import { ToolingStepBaseComponent } from '../tooling-step-base.component';
import { GridCheckboxConfigV2, GridV2Module } from '@schenck/rotec-components';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'ma-tooling-step',
  templateUrl: './tooling-step.component.html',
  styleUrls: ['./tooling-step.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TranslatePipe, TranslateDirective, GridV2Module, AsyncPipe],
})
export class ToolingStepComponent extends ToolingStepBaseComponent {
  @Input() public edit: boolean;
  @Input() public toolingSearchService: ToolingSearchService;
  @Input('height') public set gridHeight(value: number) {
    const heightToExclude = 210; // 210px consist of: 85px - grid header height; 90px - grid filter panel height; 35px - bottom margin adn borders

    if (value > heightToExclude) {
      this.height = value - heightToExclude;
    }
  }

  public stepForm = new UntypedFormGroup({
    selectedIds: new UntypedFormControl('', Validators.required),
  });
  public selectConfig: GridCheckboxConfigV2 = {
    checkboxAlwaysVisible: true,
    checkboxToggleOnWholeRow: true,
    checkboxesEnabled: true,
  };
  public height = 400;

  public get valid(): boolean {
    return !!this.toolingSearchService?.state.selectedIds?.length;
  }

  public setSelectedToolingIds(selectedIds: string[]): void {
    this.toolingSearchService?.setSelected(selectedIds);
    this.stepForm.patchValue({ selectedIds });
  }
}
